module.exports = __webpack_public_path__ + "img/0c579bc8a94b3ebc756e8aa20a187bad.png";